import React from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { AlertTriangle } from 'lucide-react';
import './UnsavedChangesModal.css';

const UnsavedChangesModal = ({ show, onConfirm, onCancel, loading = false }) => {
    return (
        <Modal
            isOpen={show}
            toggle={onCancel}
            centered
            size="md"
            className="unsaved-changes-modal"
            backdrop="static"
            fade={true}
        >
            <div className="unsaved-card">
                {/* Modal Header */}
                <div className="unsaved-header">
                    <div className="header-icon-wrapper">
                        <AlertTriangle size={20} />
                    </div>
                    <div>
                        <h3>Leave Without Saving?</h3>
                    </div>
                </div>

                {/* Modal Body */}
                <ModalBody className="unsaved-body">
                    <p className="unsaved-text">
                        This keyword will not be saved until you track at least one keyword. Are you sure you want to discard your changes?
                    </p>

                    {/* Action Buttons */}
                    <div className="unsaved-actions">
                        <Button
                            className="btn-modal-action btn-cancel-modal"
                            onClick={onCancel}
                            disabled={loading}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="btn-modal-action btn-leave-modal"
                            onClick={onConfirm}
                            disabled={loading}
                        >
                            {loading ? 'Leaving...' : 'Leave Anyway'}
                        </Button>
                    </div>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default UnsavedChangesModal;
